import { render, staticRenderFns } from "./pending-transactions.component.vue?vue&type=template&id=4aaf3260&"
import script from "./pending-transactions.component.vue?vue&type=script&lang=ts&"
export * from "./pending-transactions.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports